import { render, staticRenderFns } from "./BoardsHome.vue?vue&type=template&id=d5c814e0&"
import script from "./BoardsHome.vue?vue&type=script&lang=js&"
export * from "./BoardsHome.vue?vue&type=script&lang=js&"
import style0 from "./BoardsHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports